import { Button, Col, Form, Input, Row, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/AddArticle.css';

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 },
};

function AddSurfSpotGeo(props) {
  const [surfSpotGeoId, setSurfSpotGeoId] = useState(props.match.params.id);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (surfSpotGeoId) {
      getSurfSpotGeoInfo()
    }
  }, [surfSpotGeoId])

  const getSurfSpotGeoInfo = () => {
    axios({
      method: 'get',
      url: servicePath.getSurfSpotGeoInfo + "/" + surfSpotGeoId,
    }).then(res => {
      if (res.data.code == 1) {
        const data = res.data.data;
        setFields([
          { name: ['surfspotgeo', 'district'], value: data.district },
          { name: ['surfspotgeo', 'province'], value: data.province },
          { name: ['surfspotgeo', 'longitude'], value: data.longitude },
          { name: ['surfspotgeo', 'latitude'], value: data.latitude },
          { name: ['surfspotgeo', 'country'], value: data.country }
        ]);
      }
    })
  }

  const onFinish = values => {
    const formData = new FormData();
    formData.append("district", values.surfspotgeo.district);
    formData.append("province", values.surfspotgeo.province);
    formData.append("longitude", values.surfspotgeo.longitude);
    formData.append("latitude", values.surfspotgeo.latitude);
    formData.append("country", values.surfspotgeo.country);
  
    if (surfSpotGeoId) {
      formData.append("id", surfSpotGeoId);
      axios({
        method: 'post',
        url: servicePath.editSurfSpotGeo,
        data: formData
      }).then(res => {
        if (res.data.code == 1) {
          message.success('修改成功');
          props.history.push('/surfspotgeo/list');
        }
      })
    } else {
      axios({
        method: 'post',
        url: servicePath.addSurfSpotGeo,
        data: formData
      }).then(res => {
        if (res.data.code == 1) {
          message.success('添加成功');
          props.history.push('/surfspotgeo/list');
        }
      }).catch(err => {
        console.log('err:', err);
      })
    }
  };

  return (
    <Form 
      name="surfspotgeo-form" 
      fields={fields} 
      onFinish={onFinish}
      {...layout}
    >
      <Row gutter={12}>
        <Col span={20}>
          {surfSpotGeoId && <Form.Item label="浪点地理ID">
            <Input defaultValue={surfSpotGeoId} disabled />
          </Form.Item>}
          
          <Form.Item 
            label="区域" 
            name={['surfspotgeo', 'district']}
            rules={[{ required: true, message: '请输入区域!' }]}
          >
            <Input placeholder="请输入区域" />
          </Form.Item>
          
          <Form.Item 
            label="省份" 
            name={['surfspotgeo', 'province']}
            rules={[{ required: true, message: '请输入省份!' }]}
          >
            <Input placeholder="请输入省份" />
          </Form.Item>
          
          <Form.Item 
            label="经度" 
            name={['surfspotgeo', 'longitude']}
            rules={[{ required: true, message: '请输入经度!' }]}
          >
            <Input placeholder="请输入经度" type="number" step="any" />
          </Form.Item>
          
          <Form.Item 
            label="纬度" 
            name={['surfspotgeo', 'latitude']}
            rules={[{ required: true, message: '请输入纬度!' }]}
          >
            <Input placeholder="请输入纬度" type="number" step="any" />
          </Form.Item>
          
          <Form.Item 
            label="国家" 
            name={['surfspotgeo', 'country']}
            rules={[{ required: true, message: '请输入国家!' }]}
          >
            <Input placeholder="请输入国家" />
          </Form.Item>
        </Col>
        
        <Col span={4}>
          <Button 
            type="primary" 
            size="large" 
            htmlType="submit"
            style={{ width: '100%' }}
          >
            {surfSpotGeoId ? '修改浪点地理' : '添加浪点地理'}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default AddSurfSpotGeo